// Multi-line text input. Use for description / notes / addresses with newlines.

interface TextAreaFieldProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  hint?: string;
  rows?: number;
  disabled?: boolean;
  required?: boolean;
  dir?: 'ltr' | 'rtl';
}

export function TextAreaField({
  label,
  value,
  onChange,
  placeholder,
  hint,
  rows = 4,
  disabled,
  required,
  dir,
}: TextAreaFieldProps) {
  return (
    <label className="flex flex-col gap-1">
      <span className="text-[11px] font-medium uppercase tracking-wide text-[color:var(--bo-mute)]">
        {label}
        {required ? <span className="ms-0.5 text-[#9f1239]">*</span> : null}
      </span>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        dir={dir}
        className="w-full resize-y rounded-md border border-[color:var(--bo-line)] bg-white px-3 py-2 text-[13px] leading-relaxed text-[color:var(--bo-ink)] focus:border-[color:var(--bo-mute)] focus:outline-none disabled:cursor-not-allowed disabled:bg-[color:var(--bo-bg)]"
      />
      {hint ? <span className="text-[11px] text-[color:var(--bo-mute)]">{hint}</span> : null}
    </label>
  );
}
